import type { VisitTemplate } from '../data/templates';

interface Props {
  template: VisitTemplate;
}

export function ChartHeader({ template }: Props) {
  return (
    <div className="chart-header">
      <div className="chart-header-main">
        <h1 className="chart-patient-name">{template.patientName}</h1>
        <div className="chart-demographics">
          <span>{template.age}yo {template.sex === 'F' ? 'Female' : 'Male'}</span>
          <span className="separator">|</span>
          <span>DOB: {template.dob}</span>
          <span className="separator">|</span>
          <span>{template.visitDate}</span>
        </div>
      </div>
      <div className="chart-chief-complaint">
        <span className="cc-label">CC:</span> {template.chiefComplaint}
      </div>
    </div>
  );
}
